module.exports = __webpack_public_path__ + "img/tk-bottom.8fdcb7ba.png";